module.exports = __webpack_public_path__ + "static/media/Tire-white.4d19bad7.svg";